export class Cartao {
  public NomeComprador = '';
  public Numero = '';
  public Bandeira = '';
  public DataValidade = '';
  public CodigoSeguranca = '';
  public DataCadastro = '';
  public Token = '';
  public Validacao: any = {};
}
